import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const HomeIcon = props => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={26}
    viewBox="0 0 24 26"
    fill="none"
    {...props}>
    <Path
      fill="#8697AB"
      fillRule="evenodd"
      d="M14.077 3.371a2.998 2.998 0 0 0-4.154 0L3.754 9.295a.999.999 0 0 0-.29.54 36.518 36.518 0 0 0-.162 12.212l.15.962h3.969V14.72a1 1 0 0 1 1-1h7.158a1 1 0 0 1 1 1v8.289h3.968l.15-.962c.633-4.05.578-8.179-.16-12.211a1 1 0 0 0-.291-.54L14.077 3.37ZM8.538 1.927a4.997 4.997 0 0 1 6.924 0l6.168 5.924c.454.436.76 1.004.873 1.624.78 4.254.837 8.608.17 12.881l-.24 1.545c-.1.639-.65 1.11-1.296 1.11H15.58a1 1 0 0 1-1-1.001v-8.29H9.42v8.29a1 1 0 0 1-1 1H2.863c-.646 0-1.196-.47-1.296-1.11l-.24-1.544a38.521 38.521 0 0 1 .17-12.881c.113-.62.418-1.188.873-1.624l6.168-5.924Z"
      clipRule="evenodd"
    />
  </Svg>
);
export default HomeIcon;
